var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrenchFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_10449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H1V25H25V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_10449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0166 1.68115V24.3172C19.3546 23.4872 21.3782 21.9535 22.8093 19.9268C24.2404 17.9002 25.0088 15.4801 25.0088 12.9992C25.0088 10.5182 24.2404 8.09808 22.8093 6.07146C21.3782 4.04483 19.3546 2.51114 17.0166 1.68115Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98145 1.69904V24.299C11.5781 25.2282 14.4156 25.2345 17.0164 24.317V1.68404C14.416 0.765564 11.5785 0.770861 8.98145 1.69904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98263 1.68311V24.3151C6.64598 23.4843 4.62381 21.9505 3.19381 19.9244C1.76381 17.8982 0.996094 15.4791 0.996094 12.9991C0.996094 10.5191 1.76381 8.1 3.19381 6.07385C4.62381 4.0477 6.64598 2.51391 8.98263 1.68311Z",
    fill: "#0B318F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "#BCD6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrenchFlag);
export default __webpack_public_path__ + "static/media/french-flag.babc26270b04e53d7e22cd790ca66e50.svg";
export { ForwardRef as ReactComponent };